import "./CheckBox.scss";

const CheckBox = ({ type, isChecked, onClick, className, disabled = false }) => {
  let checkBoxStyle = "inActiveUnchecked";
  if (type) {
    switch (type) {
      case "ACTIVE":
        checkBoxStyle = isChecked ? "activeChecked" : "activeUnchecked";
        break;
      case "PRIMARY-ACTIVE":
        checkBoxStyle = isChecked
          ? "primaryActiveChecked"
          : "primaryActiveUnchecked";
        break;

      default:
        checkBoxStyle = isChecked ? "activeChecked" : "activeUnchecked";
        break;
    }
  } else {
    checkBoxStyle = "inActiveUnchecked";
  }
  return (
    <div className="custom-check-box-container">
      <div className={`checkbox-block ${className || ""}`}>
        <input type="checkbox" onClick={onClick} disabled={disabled}
        />
        <span
          className={checkBoxStyle}
          aria-label="Check box"
          onClick={!disabled ? onClick : undefined}
          onKeyDown={!disabled ? onClick : undefined}
          role="button"
          tabIndex={!disabled ? 0 : -1}

        />
      </div>
    </div>
  );
};
export default CheckBox;
